import { render, staticRenderFns } from "./trainVideoConfig.vue?vue&type=template&id=7cd3edbb&scoped=true"
import script from "./trainVideoConfig.vue?vue&type=script&lang=js"
export * from "./trainVideoConfig.vue?vue&type=script&lang=js"
import style0 from "./trainVideoConfig.vue?vue&type=style&index=0&id=7cd3edbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd3edbb",
  null
  
)

export default component.exports